import * as React from 'react';
import { Textarea, ValidationLevel } from 'ui';
import { DuplicateRowsFieldProps, IndicatorFactorsPicker } from 'app/area/indicator-factors/types';
import { isCommentsValid } from 'app/area/indicator-factors/list/duplicate-rows/duplicate-rows-helpers';

export const Comments = (props: DuplicateRowsFieldProps) => {
  const { list: { duplicateRows: { form } = {} }, validation, translation } = props;

  const codetableKey = IndicatorFactorsPicker.comments;
  const valueItem = form?.[codetableKey];

  const warningValidation = isCommentsValid(form) && {
    level: ValidationLevel.warning, messages: [{
      level: ValidationLevel.warning,
      message: translation.duplicate_comments_warning
    }]
  };

  const commentsValidation = { ...warningValidation, ...validation?.comments };

  const onChange = (value: string) => {
    const trimmedValue = value?.trim();
    props.resetValidation(codetableKey);
    props.updateByKey(codetableKey, trimmedValue);
  };

  return <Textarea
    componentId={codetableKey}
    label={{ text: translation.comments, required: false }}
    value={valueItem}
    info={{ text: translation.duplicate_comments_info, visible: true }}
    validation={commentsValidation}
    onChange={onChange}
    maxLength={4000} />;
};
